module.exports = __webpack_public_path__ + "ccda389c3c33c1db6576d89eefec39df.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-8.png
// module id = 1660
// module chunks = 0